import { checkRole } from '../utils';
import { useLoggedInUser } from './useLoggedInUser';

export const useRole = (role: string) => {
  const { roleNames } = useLoggedInUser();
  const hasAccess = checkRole(role, roleNames);
  return hasAccess;
};
